import { internalLogger } from '../../../interface/v1/clientOsLogger';
import { ConsolePlugin, JWebWindow } from '../types';

/**
 * Facade for ConsolePlugin operations (Native & Web)
 */
export class ConsolePluginFacade {
  /**
   * This method is sync since it only checks if the Console plugin is available.
   */
  public static getConsolePlugin(): ConsolePlugin | undefined {
    const windowConsolePlugin: ConsolePlugin = (window as JWebWindow)?.JWeb
      ?.Plugins?.Console;

    if (windowConsolePlugin === undefined) {
      internalLogger?.error(
        'Unable to obtain ConsolePlugin (missing some JWeb plugin)'
      );
    }
    return windowConsolePlugin;
  }
}
